import React from "react";
import { StyledModalSidebar } from "./styles";

import brand from "../../../config/brand";
import { TvLogoIcon } from "../../../assets/BrandLogo";
import { ReactComponent as BONUS_BATTLES } from "../../../assets/images/Bonus_Battle.svg";
import { ReactComponent as CASINO_IMG } from "../../../assets/images/Frame (9).svg";
import { ReactComponent as GAME_SHOWS } from "../../../assets/images/Hat.svg";
import { ReactComponent as LIVE_CASINO } from "../../../assets/images/Live Casino.svg";
import { ReactComponent as WITH_SIDEBETS } from "../../../assets/images/WithSidebets.svg";

const BUTTONS_CASINO = [
  { icon: <BONUS_BATTLES />, category: "Casino", label: "Casino", subcategory: "TV_ORIGINALS" },
  { icon: <CASINO_IMG />, category: "Casino", label: "All Games", subcategory: "TV_ORIGINALS" },
  { icon: <TvLogoIcon size={18} />, category: "Casino", label: brand.originalsLabel, subcategory: "TV_ORIGINALS" },
  { icon: <CASINO_IMG />, category: "Casino", label: "Slots", subcategory: "SLOTS" },
  { icon: <GAME_SHOWS />, category: "Casino", label: "Shows", subcategory: "GAME_SHOWS" },
  { icon: <LIVE_CASINO />, category: "Casino", label: "Live", subcategory: "LIVE_CASINO" },
  { icon: <WITH_SIDEBETS />, category: "Casino", label: "Sidebets", subcategory: "WITH_SIDEBETS" },
  { icon: <BONUS_BATTLES />, category: "Casino", label: "Battles", subcategory: "BONUS_BATTLES" },
];

const ModalSidebar = ({ selectedCategory, onCategoryChange }) => {
  return (
    <StyledModalSidebar>
      {BUTTONS_CASINO.map((button, index) => (
        <div
          className={`option ${
            button.label === selectedCategory ? "active" : ""
          }`}
          onClick={() => {
            onCategoryChange(button);
          }}
        >
          {button.icon && (
            <div
              className={`icon ${
                button.label === selectedCategory ? "active-icon" : ""
              }`}
            >
              {button.icon}
            </div>
          )}
          {button.label}
        </div>
      ))}
    </StyledModalSidebar>
  );
};

export default ModalSidebar;
